<template>
  <div class="row overflow-auto" style="max-height: 800px" id="container_imagens">
    <!-- Se não houver imagens -->
    <div v-if="!dados.length" class="col-12 text-center text-muted py-3">
      Não há imagens para exibir.
    </div>

    <!-- Se houver imagens -->
    <div
      v-else
      v-for="imagem in dados"
      :key="imagem.id"
      :id="'linha_' + imagem.key + '_img'"
      class="col-md-4 imagem-card"
    >
     <Card style="width: 15rem; overflow: hidden">
        <template #header>
          <Image :src="'data:image/png;base64,' + imagem.imagem" :alt="imagem.descricao_imagem" width="259" preview />
        </template>
        <template #content>
          <span class="text-center"><strong>{{ imagem.descricao }}</strong></span>
          <div class="pull-right">
            <button class="btn btn-danger btn-xs font-bold" @click="deletarDado(imagem.key, imagem.id, imagem.descricao)">
              <i class="fa fa-trash"></i>
            </button>
          </div>
        </template>
      </Card>
    </div>
  </div>

  <br />
  <hr />

  <div class="float-right">
    <button type="submit" class="btn btn-primary" @click="abrirModal('cadastroImg')">Adicionar Imagem</button>
  </div>
  <button class="btn btn-success" @click="$emit('fechar')">Fechar</button>

  <BaseImgCadastro
    v-if="exibirModal === 'cadastroImg'"
    :origemId="itemKey"
    :origemApp="'ANALISES'"
    @fecharSubModal="exibirModal = false"
    @atualizarListaImg="atualizarImg"
  />
</template>

<script>
import {apiRequest, alertDelete} from '@/../public/js/utils/funcoes';
import {apiUrl} from "@/router/apiBackRoutes"
import BaseImgCadastro from '@/components/base/BaseImgCadastro.vue';


export default {
  name: 'ImagensAnalise',
  props: {
    itemKey: String,
  },
  components: {
    BaseImgCadastro,
  },
  emits: ['fechar', 'fecharSubModal',],
  data() {
    return {
      dados: [],
      erro: null,
      imgSelect: null,
      exibirModal: false
    }
  },
  methods: {
    atualizarImg(novaImg) {
      if (Array.isArray(novaImg)) {
        this.dados.push(...novaImg);
      } else {
        this.dados.push(novaImg);
      }
    },
    abrirModal(tipo) {
      this.exibirModal = tipo;
    },
    deletarDado(imgKey, imgId, imgDescricao) {
      let url = apiUrl.imagens.destroy(imgKey);
      alertDelete(imgKey, url, 'Você deseja deletar o registro?', `ID: ${imgId} | ${imgDescricao}`);
    },
    async getDados() {
      const resultado = await apiRequest("GET", apiUrl.imagens.list(this.itemKey));
      if (resultado.success) {
        this.dados = resultado.data.data;
      }
    },
  },
  mounted() {
    this.getDados();
  },
}
</script>
